function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLunchtimeClock = function SvgLunchtimeClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.24 53"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M43.24 15.83 38.42 11l-3.64 3.63A21.44 21.44 0 0 0 25 10.31V6h4.5V0h-16v6H18v4.31A21.49 21.49 0 1 0 43 31.5a21.25 21.25 0 0 0-3.59-11.84ZM18 34h7V18h-7Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};
export default SvgLunchtimeClock;